export function getGraphQLError(e) {

    if((e.graphQLErrors || []).length > 0){
        return e.graphQLErrors[0];
    }

    if((e.clientErrors || []).length > 0){
        return e.clientErrors[0];
    }

    if(e.networkError){

        if(e.networkError.result?.errors?.length){
            return e.networkError.result.errors[0];
        }

        return e.networkError;
    }

    return null;
}